export const enabledLanguageKey = "languages-enabled";
export const languageProfileKey = "languages-profiles";
export const notificationsKey = "notifications-providers";

export const pathMappingsKey = "settings-general-path_mappings";
export const pathMappingsMovieKey = "settings-general-path_mappings_movie";

export const seriesEnabledKey = "settings-general-use_sonarr";
export const moviesEnabledKey = "settings-general-use_radarr";
